export * from "./scales-card";
export * from "./scales-critical";
export * from "./scales-dynamics-chart";
